import styled from 'styled-components/macro';
import { ButtonText, TicketsFiltersSelectText } from './fontElements';
import { baseBackground, formInputTextForFilledBack, whiteText } from './colorConstants';
import * as colors from 'components/common/colorConstants';

export const HiddenText = styled.span`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  position: absolute;
`;

export const Label = styled.label`
  margin-top: 30px;
  display: block;
  font-weight: bold;
`;
export const SubLabel = styled.label`
  margin: 10px 0;
  font-weight: normal;
  display: block;
  color: gray;
  font-size: 12px;
  line-height: 1.5;
`;

export const SimplrButton = styled(ButtonText)`
  background-color: #44b1df;
  border: 0;
  border-radius: 22px;
  color: ${whiteText};
  font-weight: normal;
  vertical-align: middle;
  padding: 4px 20px;
  transition: 0.3s;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};

  &:focus {
    border: 1px solid lightblue;
  }
`;

export const DropdownSelect = styled(TicketsFiltersSelectText)`
  width: 100%;
  height: 24px;
  appearance: none;
  padding: 0 20px 0 7px;
  color: ${formInputTextForFilledBack};
  border: 1px solid #e1e6f2;
  border-radius: 4px;
  display: block;
  background: url('/images/new-designs/solid-arrow-up.svg') no-repeat,
    url('/images/new-designs/solid-arrow-down.svg') no-repeat ${baseBackground};
  background-size: 6px;
  background-position: right 10px top 5px, right 10px bottom 5px;

  &:focus {
    outline: none;
  }
`;

export const TextInput = styled.input`
  padding: 8px 10px;
  width: 100%;
  border-radius: 4px;
  border: ${(props) => (props.errorPresent ? `1px solid ${colors.red3}` : `1px solid ${colors.lightGray18}`)};
  &:hover {
    outline: ${(props) => props.errorPresent && 'none'};
    border: ${(props) => (props.errorPresent ? `1px solid ${colors.red3}` : `1px solid ${colors.lightGray19}`)};
  }
  &:focus {
    outline: ${(props) => props.errorPresent && 'none !important'};
    border: ${(props) =>
      props.errorPresent ? `1px solid ${colors.red3}` : `1px solid ${colors.lightGray19} !important`};
  }
  ::placeholder {
    opacity: 0.6;
  }
`;
